<template>
  <div class="template">
    <section class="py-24 bg-slate-50 dark:bg-slate-900/50">
      <div class="container mx-auto px-6">
        <div class="text-center mb-16">
          <h2 class="text-3xl font-bold text-slate-900 dark:text-white mb-4">
            CERTIFICATES
          </h2>
          <div class="w-16 h-1 bg-primary mx-auto"></div>
        </div>

        <div class="gap-8">
          <div class="relative flex items-center">
            <button
              @click="prev"
              class="absolute -left-4 md:-left-10 z-10 p-2 text-gray-400 hover:text-blue-600 transition-colors"
            >
              <svg
                class="w-8 h-8"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M15 19l-7-7 7-7"
                />
              </svg>
            </button>

            <div class="overflow-hidden w-full">
              <div
                class="flex transition-transform duration-500 ease-in-out"
                :style="{ transform: `translateX(-${currentIndex * 100}%)` }"
              >
                <div
                  v-for="(group, gIndex) in groupedProducts"
                  :key="gIndex"
                  class="w-full flex-shrink-0 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4"
                >
                  <div
                    v-for="(item, index) in group"
                    :key="index"
                    class="bg-white flex flex-col items-center shadow-sm hover:shadow-md transition-shadow"
                  >
                    <div
                      class="w-full aspect-[4/4] flex items-center justify-center mb-4 overflow-hidden border border-gray-50"
                    >
                      <img
                        :src="item.url"
                        class="object-contain max-h-full hover:scale-110 transition-transform duration-500"
                        :alt="item.name"
                      />
                    </div>
                    <div class="text-center py-5">{{ item.message }}</div>
                  </div>
                </div>
              </div>
            </div>

            <button
              @click="next"
              class="absolute -right-4 md:-right-10 z-10 p-2 text-gray-400 hover:text-blue-600 transition-colors"
            >
              <svg
                class="w-8 h-8"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M9 5l7 7-7 7"
                />
              </svg>
            </button>
          </div>

          <div class="flex justify-center mt-8 space-x-2">
            <span
              v-for="(_, i) in groupedProducts"
              :key="i"
              class="w-2 h-2 rounded-full cursor-pointer transition-colors"
              :class="currentIndex === i ? 'bg-blue-600' : 'bg-gray-300'"
              @click="currentIndex = i"
            ></span>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'Template',
  components: {},
  data() {
    return {
      currentIndex: 0,
      offset: 0,
      autoScrollSpeed: 1,
      autoScrollEnabled: true,
      animationFrameId: null,
      itemWidth: 304, // 288px (w-72) + 16px (px-2)
      images: [
        {
          url: require('@/assets/cert/cert-06.png'),
          message: 'Certificate of High-tech Enterprise'
        },
        {
          url: require('@/assets/cert/cert-02.png'),
          message: 'ISO9001'
        },
        {
          url: require('@/assets/cert/cert-01.jpg'),
          message: 'FDA'
        },
        {
          url: require('@/assets/cert/cert-03.png'),
          message: 'LFGB'
        },
        {
          url: require('@/assets/cert/cert-05.jpg'),
          message: 'RoHS'
        },
        {
          url: require('@/assets/cert/cert-04.png'),
          message: 'REACH'
        }
      ]
    }
  },
  mounted() {
    // this.startAutoScroll()
  },
  computed: {
    // 关键逻辑：将数组切割为 4 个一组的二维数组
    groupedProducts() {
      const size = 4
      const groups = []
      for (let i = 0; i < this.images.length; i += size) {
        groups.push(this.images.slice(i, i + size))
      }
      return groups
    }
  },
  methods: {
    next() {
      if (this.currentIndex < this.groupedProducts.length - 1) {
        this.currentIndex++
      } else {
        this.currentIndex = 0 // 循环
      }
    },
    prev() {
      if (this.currentIndex > 0) {
        this.currentIndex--
      } else {
        this.currentIndex = this.groupedProducts.length - 1 // 循环
      }
    }
  },
  beforeDestroy() {
    // cancelAnimationFrame(this.animationFrameId)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.carousel-track {
  transition: transform 3.9s ease;
}
.carousel-img {
  transition: transform 3.9s ease;
}
.carousel-img:hover {
  transform: scale(1.05);
}
</style>



// WEBPACK FOOTER //
// src/page/index/OurCertificates.vue